import { API_ROOT } from 'src/constants';
import Request, { setMethod, setURL } from '../index';
import { getNamespaceName } from '../objects/namespaces';

/**
 * getGraphQLAuthToken
 *
 * gets graphql auth token from api
 *
 * @param force { boolean } used to get new token forcefully.
 * @param environment {  }
 */
export const getGraphQLAuthToken = (environment: string = 'app') =>
    Request<any>(
        setURL(`${API_ROOT}/${getNamespaceName()}/services/auth/graphql?endpoint_for=${environment}`),
        setMethod('GET')
    ).then((response) => response.data);


/**
 * getGraphQLAuthToken
 *
 * gets graphql auth token from api
 *
 * @param force { boolean } used to get new token forcefully.
 * @param environment {  }
 */
export const getGraphQLPublicAuthToken = () =>
    Request<any>(
        setURL(`${API_ROOT}/${getNamespaceName()}/services/auth/graphql/public?endpoint_for=app`),
        setMethod('GET')
    ).then((response) => response.data);
